import * as C from '../../constants';
import defaultState from './defaultState';

export default {

  [C.SKI_RENTAL_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Seasons
  [C.SKI_RENTAL_SEASONS_LOAD_PENDING](state) {
    state.seasons = {
      ...state.seasons,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASONS_LOAD_FAILURE](state, payload) {
    state.seasons = {
      ...state.seasons,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_SEASONS_LOAD_SUCCESS](state, payload) {
    state.seasons = {
      ...state.seasons,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Season
  [C.SKI_RENTAL_SEASON_LOAD_PENDING](state) {
    state.season = {
      ...state.season,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASON_LOAD_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_SEASON_LOAD_SUCCESS](state, payload) {
    const payloadCopy = Object.assign({}, payload);
    const newSeasonItem = {
      ...state.season,
      ...Object.assign({}, state.season.newSeasonItem),
    };
    if (payloadCopy.periods) {
      newSeasonItem.periodDates.items = payloadCopy.periods;
      delete payloadCopy.periods;
    }
    if (payloadCopy.discounts) {
      newSeasonItem.discounts.items = payloadCopy.discounts;
      delete payloadCopy.discounts;
    }
    if (payloadCopy.prices) {
      newSeasonItem.prices.items = payloadCopy.prices;
      delete payloadCopy.prices;
    }
    if (payloadCopy.personCategories) {
      newSeasonItem.personCategories.items = payloadCopy.personCategories;
      delete payloadCopy.personCategories;
    }
    if (payloadCopy.seasonAreas) {
      newSeasonItem.skiAreas.ids = payloadCopy.seasonAreas;
      delete payloadCopy.seasonAreas;
    }
    const seasonItem = {
      ...newSeasonItem,
      ...payloadCopy,
    };
    state.season = {
      ...state.season,
      ...seasonItem,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASON_CREATE_PENDING](state) {
    state.season = {
      ...state.season,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASON_CREATE_SUCCESS](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASON_CREATE_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_SEASON_SAVE_PENDING](state) {
    state.season = {
      ...state.season,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASON_SAVE_SUCCESS](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_SEASON_SAVE_FAILURE](state, payload) {
    state.season = {
      ...state.season,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Suppliers
  [C.SKI_SUPPLIERS_LOAD_PENDING](state) {
    state.suppliers = {
      ...state.suppliers,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_SUPPLIERS_LOAD_SUCCESS](state, payload) {
    state.suppliers = {
      ...state.suppliers,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SUPPLIERS_LOAD_FAILURE](state, payload) {
    state.suppliers = {
      ...state.suppliers,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_SEASON_SET](state, payload) {
    state.season = {
      ...state.season,
      ...payload,
    };
  },
  // endregion

  // region Price Combinations
  [C.SKI_RENTAL_PRICE_COMBINATIONS_LOAD_PENDING](state) {
    state.season.priceCombinations = {
      ...state.season.priceCombinations,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_PRICE_COMBINATIONS_LOAD_SUCCESS](state, payload) {
    state.season.priceCombinations = {
      ...state.season.priceCombinations,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_COMBINATIONS_LOAD_FAILURE](state, payload) {
    state.season.priceCombinations = {
      ...state.season.priceCombinations,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    selectedNumberOfDays.sort((a, b) => a - b);
    state.season.priceCombinations.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_PERSON_CATEGORY_SET](state, selectedPersonCategoryIds) {
    state.season.priceCombinations.selectedPersonCategoryIds = selectedPersonCategoryIds;
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_LEVEL_SET](state, selectedLevelIds) {
    state.season.priceCombinations.selectedLevelIds = selectedLevelIds;
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_PACKAGE_SET](state, selectedPackageIds) {
    state.season.priceCombinations.selectedPackageIds = selectedPackageIds;
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_SKI_TYPE_SET](state, selectedSkiTypeIds) {
    state.season.priceCombinations.selectedSkiTypeIds = selectedSkiTypeIds;
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_CLEAR_FILTERS_SET](state) {
    state.season.priceCombinations.selectedNumberOfDays = [];
    state.season.priceCombinations.selectedPersonCategoryIds = [];
    state.season.priceCombinations.selectedLevelIds = [];
    state.season.priceCombinations.selectedPackageIds = [];
    state.season.priceCombinations.selectedSkiTypeIds = [];
  },

  [C.SKI_RENTAL_PRICE_COMBINATION_ONLY_SHOW_SAVED_PRICES_SET](state, onlyShowSavedPrices) {
    if (onlyShowSavedPrices) {
      state.season.priceCombinations.selectedNumberOfDays
        = state.season.priceCombinations.defaultNumberOfDays;
    }
    state.season.priceCombinations.onlyShowSavedPrices = onlyShowSavedPrices;
  },
  // endregion

  // region Person Categories
  [C.SKI_RENTAL_PERSON_CATEGORIES_LOAD_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORIES_LOAD_SUCCESS](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORIES_LOAD_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_ADD](state) {
    const newPersonCategory = Object.assign({}, state.season.personCategories.newItem);
    newPersonCategory.skiRentalSeasonId = state.season.id;
    state.season.personCategories.items = [
      newPersonCategory,
      ...Object.values(state.season.personCategories.items),
    ];
  },

  [C.SKI_RENTAL_PERSON_CATEGORIES_SET](state, payload) {
    const personCategoryItem = {
      ...Object.assign({}, payload.personCategoryItem),
      ...payload.params,
    };
    const items = Object.values(state.season.personCategories.items).map(
      personCategory => (
        personCategory.id === personCategoryItem.id ? personCategoryItem : personCategory
      ),
    );
    state.season.personCategories.items = {
      ...items,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_CREATE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_CREATE_SUCCESS](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_CREATE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_SAVE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.personCategories.items)
      .map(personCategory => (personCategory.id === payload.id ? payload : personCategory));
    state.season.personCategories = {
      ...state.season.personCategories,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_SAVE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_REMOVE_PENDING](state) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.personCategories.items)
      .filter(personCategory => personCategory.id !== payload);
    state.season.personCategories = {
      ...state.season.personCategories,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERSON_CATEGORY_REMOVE_FAILURE](state, payload) {
    state.season.personCategories = {
      ...state.season.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Discounts
  [C.SKI_RENTAL_DISCOUNTS_LOAD_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNTS_LOAD_SUCCESS](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNTS_LOAD_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_ADD](state) {
    const newDiscount = Object.assign({}, state.season.discounts.newItem);
    newDiscount.skiRentalSeasonId = state.season.id;
    state.season.discounts.items = [newDiscount, ...state.season.discounts.items];
  },

  [C.SKI_RENTAL_DISCOUNT_SET](state, payload) {
    let discountItem = Object.assign({}, payload.discountItem);
    discountItem = {
      ...discountItem,
      ...payload.params,
    };
    const items = Object.values(state.season.discounts.items)
      .map(
        discount => (discount.id === discountItem.id ? discountItem : discount),
      );
    state.season.discounts.items = {
      ...items,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_CREATE_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_CREATE_SUCCESS](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_CREATE_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_SAVE_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_SAVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.discounts.items)
      .map(discount => (discount.id === payload.id ? payload : discount));
    state.season.discounts = {
      ...state.season.discounts,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_SAVE_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_REMOVE_PENDING](state) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_REMOVE_SUCCESS](state, payload) {
    const items = Object.values(state.season.discounts.items)
      .filter(discount => discount.id !== payload);
    state.season.discounts = {
      ...state.season.discounts,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_REMOVE_FAILURE](state, payload) {
    state.season.discounts = {
      ...state.season.discounts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_PENDING](state) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_SUCCESS](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_SAVE_FAILURE](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_PENDING](state) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_SUCCESS](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_DISCOUNT_PERSON_CATEGORY_DELETE_FAILURE](state, payload) {
    state.season.discounts.personCategories = {
      ...state.season.discounts.personCategories,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Ski Rental Areas
  [C.SKI_RENTAL_AREAS_LOAD_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_AREAS_LOAD_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_AREAS_LOAD_FAILURE](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_AREAS_SAVE_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_AREAS_SAVE_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_AREAS_SAVE_FAILURE](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_AREAS_DELETE_PENDING](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_AREAS_DELETE_SUCCESS](state, payload) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      items: payload,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_AREAS_DELETE_FAILURE](state) {
    state.season.skiAreas = {
      ...state.season.skiAreas,
      saveLoading: false,
      saveError: undefined,
    };
  },
  // endregion

  // region Period Dates
  [C.SKI_RENTAL_PERIOD_DATES_LOAD_PENDING](state) {
    state.season.periodDates = {
      ...state.season.periodDates,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_PERIOD_DATES_LOAD_SUCCESS](state, payload) {
    state.season.periodDates = {
      ...state.season.periodDates,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATES_LOAD_FAILURE](state, payload) {
    state.season.periodDates = {
      ...state.season.periodDates,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATES_SET](state, payload) {
    let periodDateItem = Object.assign({}, payload.periodItem);
    periodDateItem = {
      ...periodDateItem,
      ...payload.params,
    };
    const items = Object.values(state.season.periodDates.items)
      .map(
        periodDate => (periodDate.id === periodDateItem.id ? periodDateItem : periodDate),
      );
    state.season.periodDates.items = {
      ...items,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATE_ADD](state) {
    const newPeriodDate = Object.assign({}, state.season.periodDates.newPeriodItem);
    newPeriodDate.skiRentalSeasonId = state.season.id;
    state.season.periodDates.items = [
      newPeriodDate,
      ...state.season.periodDates.items,
    ];
  },

  [C.SKI_RENTAL_PERIOD_DATE_CREATE_PENDING](state) {
    state.season.periodDates = {
      ...state.season.periodDates,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATE_CREATE_SUCCESS](state) {
    state.season.periodDates = {
      ...state.season.periodDates,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATE_CREATE_FAILURE](state, payload) {
    state.season.periodDates = {
      ...state.season.periodDates,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATE_DELETE_PENDING](state) {
    state.season.periodDates = {
      ...state.season.periodDates,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATE_DELETE_SUCCESS](state, payload) {
    const items = Object.values(state.season.periodDates.items)
      .filter(periodDate => periodDate.id !== payload);
    state.season.periodDates = {
      ...state.season.periodDates,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PERIOD_DATE_DELETE_FAILURE](state, payload) {
    state.season.periodDates = {
      ...state.season.periodDates,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  // region Sales Types
  [C.SKI_RENTAL_SALES_TYPES_LOAD_PENDING](state) {
    state.salesTypes = {
      ...state.salesTypes,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_SALES_TYPES_LOAD_SUCCESS](state, payload) {
    state.salesTypes = {
      ...state.salesTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_SALES_TYPES_LOAD_FAILURE](state, payload) {
    state.salesTypes = {
      ...state.salesTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Packages
  [C.SKI_RENTAL_PACKAGES_LOAD_PENDING](state) {
    state.packages = {
      ...state.packages,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_PACKAGES_LOAD_SUCCESS](state, payload) {
    state.packages = {
      ...state.packages,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PACKAGES_LOAD_FAILURE](state, payload) {
    state.packages = {
      ...state.packages,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Levels
  [C.SKI_RENTAL_LEVELS_LOAD_PENDING](state) {
    state.levels = {
      ...state.levels,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_LEVELS_LOAD_SUCCESS](state, payload) {
    state.levels = {
      ...state.levels,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_LEVELS_LOAD_FAILURE](state, payload) {
    state.levels = {
      ...state.levels,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Ski Types
  [C.SKI_RENTAL_SKI_TYPES_LOAD_PENDING](state) {
    state.skiTypes = {
      ...state.skiTypes,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_SKI_TYPES_LOAD_SUCCESS](state, payload) {
    state.skiTypes = {
      ...state.skiTypes,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_SKI_TYPES_LOAD_FAILURE](state, payload) {
    state.skiTypes = {
      ...state.skiTypes,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Prices
  [C.SKI_RENTAL_PRICES_LOAD_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      itemsLoading: true,
      itemsError: undefined,
      items: [],
    };
  },

  [C.SKI_RENTAL_PRICES_LOAD_SUCCESS](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICES_LOAD_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_RENTAL_PRICE_SET](state, payload) {
    const currentPrice = payload.price;
    const statePrices = Object.values(state.season.prices.items);
    if (!statePrices.some(statePrice =>
      statePrice.id === currentPrice.id
      && statePrice.skiRentalLevelId === currentPrice.skiRentalLevelId
      && statePrice.skiRentalSkiTypeId === currentPrice.skiRentalSkiTypeId
      && statePrice.skiRentalPackageId === currentPrice.skiRentalPackageId
      && statePrice.skiRentalSeasonPersonCategoryId
      === currentPrice.skiRentalSeasonPersonCategoryId,
    )) {
      state.season.prices.items = [currentPrice, ...state.season.prices.items];
    }
    const items = state.season.prices.items.map((statePrice) => {
      let updatedPrice = statePrice;
      if (statePrice.id === currentPrice.id) {
        updatedPrice = {
          ...statePrice,
          ...payload.params,
        };
      }
      return updatedPrice;
    });
    state.season.prices.items = [
      ...items,
    ];
  },

  [C.SKI_RENTAL_PRICE_DAY_SET](state, payload) {
    const priceItem = payload.price;
    const priceId = priceItem && priceItem.id ? Number(payload.price.id) : undefined;
    if (!state.season.prices.items.some(statePrice =>
      statePrice.id === undefined
      && statePrice.skiRentalLevelId === priceItem.skiRentalLevelId
      && statePrice.skiRentalSkiTypeId === priceItem.skiRentalSkiTypeId
      && statePrice.skiRentalPackageId === priceItem.skiRentalPackageId
      && statePrice.skiRentalSeasonPersonCategoryId === priceItem.skiRentalSeasonPersonCategoryId,
    )) {
      state.season.prices.items = [priceItem, ...state.season.prices.items];
    }
    const priceDay = payload.priceDay;
    priceDay.skiRentalSeasonPriceId = priceId;
    priceDay.price = payload.priceAmount;
    const items = state.season.prices.items.map((statePrice) => {
      let days = [];
      if (statePrice.id === priceId
        && statePrice.skiRentalLevelId === priceItem.skiRentalLevelId
        && statePrice.skiRentalSkiTypeId === priceItem.skiRentalSkiTypeId
        && statePrice.skiRentalPackageId === priceItem.skiRentalPackageId
        && statePrice.skiRentalSeasonPersonCategoryId === priceItem.skiRentalSeasonPersonCategoryId
        && statePrice.days.every(stateDay =>
          stateDay.days !== priceDay.days,
        )
      ) {
        days = [priceDay, ...statePrice.days];
      } else {
        days = statePrice.days
          .map(
            day => (
              day.id === priceDay.id && day.days === priceDay.days
                ? priceDay
                : day
            ),
          );
      }
      return {
        ...statePrice,
        days,
      };
    });
    state.season.prices.items = [
      ...items,
    ];
  },

  [C.SKI_RENTAL_PRICE_ADD](state, items) {
    state.season.prices.items = {
      ...items,
    };
  },

  [C.SKI_RENTAL_PRICE_CREATE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_CREATE_SUCCESS](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_CREATE_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRICE_SAVE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_SAVE_SUCCESS](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_SAVE_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_RENTAL_PRICE_REMOVE_PENDING](state) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_REMOVE_SUCCESS](state, payload) {
    const items = state.season.prices.items.filter(price => price.id !== payload.priceId);
    state.season.prices = {
      ...state.season.prices,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_RENTAL_PRICE_REMOVE_FAILURE](state, payload) {
    state.season.prices = {
      ...state.season.prices,
      saveLoading: false,
      saveError: payload,
    };
  },
  // endregion

  [C.SKI_RENTAL_SEASON_PICK_UP_PLACES_PENDING](state) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: true,
      error: false,
      items: [],
    };
  },

  [C.SKI_RENTAL_SEASON_PICK_UP_PLACES_SUCCESS](state, payload) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: false,
      error: false,
      items: payload,
    };
  },

  [C.SKI_RENTAL_SEASON_PICK_UP_PLACES_FAILURE](state) {
    state.pickupPlaces = {
      ...state.pickupPlaces,
      loading: false,
      error: true,
      items: [],
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/mutations.js